import React from 'react';

export type WebMenuApi = {
  open: () => void;
  close: () => void;
  visible: boolean;
};

const noop: WebMenuApi = {
  open: () => undefined,
  close: () => undefined,
  visible: false,
};

/** Used on web instead of React Navigation drawer (RTL + drawer is broken in Chrome Android). */
export const WebMenuContext = React.createContext<WebMenuApi>(noop);
